import { NgModule, ModuleWithProviders } from '@angular/core';

import { AppConfigurationService } from '../common/app-configuration.service';
import { ISmartenitConfig } from '../smartenit-config.interface';
import { EventsManagerService } from '../common/events-manager.service';
import { HttpInterceptor } from '../common/http-interceptor.service';
import { AuthService } from '../auth/auth.service';
import { Oauth2Service } from '../resources/oauth-2.service';
import { ResourcesProvider } from '../resources/resources.provider';
import { WebSocketsService } from '../websockets/websockets.service';
import { AreasService } from '../resources/areas.service';
import { AccountsService } from '../resources/accounts.service';
import { StorageService } from '../storage/storage.service';
import { DatabaseService } from '../storage/database.service';
import { UsersService } from '../resources/users.service';
import { LocationsService } from '../resources/locations.service';
import { CategoriesService } from '../resources/categories.service';
import { DevicesService } from '../resources/devices.service';
import { EventsService } from '../resources/events.service';
import { ScenesService } from '../resources/scenes.service';
import { PairingsService } from '../resources/pairings.service';
import { MediaService } from '../resources/media.service';
import { MetricsService } from '../resources/metrics.service';
import { WizardsService } from '../resources/wizards.service';
import { PluginFactoryService } from '../plugins/plugin-factory.service';
import { PluginUtilsService } from '../plugins/plugin-utils.service';
import { ActionsService } from '../resources/actions.service';
import { ConditionsService } from '../resources/conditions.service';
import { EffectsService } from '../resources/effects.service';
import { LocalConnectionService } from '../common/local-connection.service';
import { DataQueryService } from '../common/data-query.service';
import { DeviceReferenceService } from '../common/device-reference.service';
import { ModelsBuilderService } from '../common/models-builder.service';
import { SmartenitTranslationService } from '../common/translation/smartenit-translation.service';
import { SyncService } from '../storage/sync.service';
import { ControllersService } from '../resources/controllers.service';
import { RespondersService } from '../resources/responders.service';
import { MicroAppsService } from '../resources/microapps.service';
import { NestService } from '../resources/external/nest.service';
import { HoneywellService } from '../resources/external/honeywell.service';
import { ProcessorValueHelperService } from '../common/processor-value-helper.service';
import { AttrReportConfigService } from '../common/attr-report-config.service';
import { SmartenitCurrencyService } from '../common/smartenit-currency.service';
import { DistanceConverterService } from '../common/distance-converter.service';
import { TemperatureConverterService } from '../common/temperature-converter.service';
import { ConnectionMonitorService } from '../common/connection-monitor.service';
import { INITIAL_CONFIG } from '../smartenit-initial-config';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { APIIRextService } from '../common/api-irext.service';
import { RheemDRService } from '../common/rheem-dr.services';

@NgModule({
  declarations: [
    // Pipes.
    // Directives.
  ],
  exports: [
    // Pipes.
    // Directives.
  ],
  imports: [
    DeviceDetectorModule.forRoot()
  ]
})
export class SmartenitModule {
  public static withConfig(config: ISmartenitConfig): ModuleWithProviders {
    return {
      ngModule: SmartenitModule,
      providers: [
        {
          provide: INITIAL_CONFIG,
          useValue: config
        },
        AppConfigurationService,
        EventsManagerService,
        HttpInterceptor,
        AuthService,
        Oauth2Service,
        ResourcesProvider,
        WebSocketsService,
        AreasService,
        AccountsService,
        StorageService,
        DatabaseService,
        UsersService,
        LocationsService,
        RespondersService,
        ControllersService,
        CategoriesService,
        DevicesService,
        EventsService,
        ScenesService,
        PairingsService,
        MediaService,
        MetricsService,
        WizardsService,
        PluginFactoryService,
        PluginUtilsService,
        ActionsService,
        EffectsService,
        ConditionsService,
        MicroAppsService,
        NestService,
        HoneywellService,
        ModelsBuilderService,
        DeviceReferenceService,
        SmartenitTranslationService,
        LocalConnectionService,
        SyncService,
        DataQueryService,
        ProcessorValueHelperService,
        AttrReportConfigService,
        SmartenitCurrencyService,
        APIIRextService,
        DistanceConverterService,
        TemperatureConverterService,
        ConnectionMonitorService,
        RheemDRService
      ]
    };
  }

  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SmartenitModule,
      providers: [
        AppConfigurationService,
        EventsManagerService,
        HttpInterceptor,
        AuthService,
        Oauth2Service,
        ResourcesProvider,
        WebSocketsService,
        AreasService,
        AccountsService,
        StorageService,
        DatabaseService,
        UsersService,
        LocationsService,
        CategoriesService,
        ControllersService,
        CategoriesService,
        DevicesService,
        EventsService,
        ScenesService,
        PairingsService,
        MediaService,
        MetricsService,
        WizardsService,
        PluginFactoryService,
        PluginUtilsService,
        ActionsService,
        EffectsService,
        ConditionsService,
        MicroAppsService,
        NestService,
        HoneywellService,
        ModelsBuilderService,
        DeviceReferenceService,
        SmartenitTranslationService,
        LocalConnectionService,
        SyncService,
        DataQueryService,
        AttrReportConfigService,
        SmartenitCurrencyService,
        APIIRextService,
        DistanceConverterService,
        TemperatureConverterService,
        ConnectionMonitorService,
        RheemDRService
      ]
    };
  }

  public static forChild(): ModuleWithProviders {
    return {
      ngModule: SmartenitModule,
      providers: [
        EventsManagerService,
        HttpInterceptor,
        AuthService,
        Oauth2Service,
        ResourcesProvider,
        WebSocketsService,
        AreasService,
        AccountsService,
        StorageService,
        DatabaseService,
        UsersService,
        LocationsService,
        ControllersService,
        CategoriesService,
        DevicesService,
        EventsService,
        ScenesService,
        PairingsService,
        MediaService,
        MetricsService,
        WizardsService,
        PluginFactoryService,
        PluginUtilsService,
        ActionsService,
        EffectsService,
        ConditionsService,
        MicroAppsService,
        NestService,
        HoneywellService,
        ModelsBuilderService,
        DeviceReferenceService,
        SmartenitTranslationService,
        LocalConnectionService,
        SyncService,
        DataQueryService,
        AttrReportConfigService,
        SmartenitCurrencyService,
        APIIRextService,
        DistanceConverterService,
        TemperatureConverterService,
        ConnectionMonitorService,
        RheemDRService
      ]
    };
  }
}
